import {
  createAppLogger,
  createModuleLogger as originalCreateModuleLogger,
} from '#packages/data-collection/services/logger';

const instance = createAppLogger('client-web');

export const createModuleLogger = originalCreateModuleLogger.bind(
  null,
  instance,
);
